import {
  faBottleWater,
  faEllipsis,
  faPills,
  faShoePrints,
  faSprayCanSparkles,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Slider } from '../components/slider/slider';
import { Settings } from 'react-slick';

const categories = [
  { title: 'Colonias', icon: faSprayCanSparkles, href: 'colonias' },
  { title: 'Zapatos', icon: faShoePrints, href: 'zapatos' },
  { title: 'Yeti', icon: faBottleWater, href: 'yeti' },
  { title: 'Adelgazadores', icon: faPills, href: 'adelgazadores' },
  { title: 'Otros', icon: faEllipsis, href: 'otros' },
] as const;

export const HomePage: FC = () => {
  const sliderResponsive: Settings['responsive'] = [
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        nextArrow: <></>,
        prevArrow: <></>,
      },
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 2,
        nextArrow: <></>,
        prevArrow: <></>,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        nextArrow: <></>,
        prevArrow: <></>,
      },
    },
  ];

  return (
    <div>
      <Slider responsive={sliderResponsive}>
        {categories.map((category) => (
          <div key={`${category.href}`}>
            <Stack sx={{ alignItems: 'center', gap: 2 }}>
              <Link to={`/${category.href}`}>
                <Stack
                  sx={{
                    height: '6rem',
                    width: '6rem',
                    borderRadius: '50%',
                    boxShadow: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    color: 'grey',
                    '&:hover': {
                      bgcolor: '#f0f0f0',
                      color: 'black',
                    },
                  }}
                >
                  <FontAwesomeIcon icon={category.icon} size="2xl" />
                </Stack>
              </Link>
              <Typography variant="h6">{category.title}</Typography>
            </Stack>
          </div>
        ))}
      </Slider>
    </div>
  );
};
